// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"9e7444a8","97":"28086cf4","330":"2844c8e6","331":"1ea6104d","453":"0a8c8b79","494":"c5654075","574":"fd41e38a","675":"0c3ef9b4","749":"c9726f9d","835":"ac94ff2b"}[chunkId] + ".chunk.js";
};